export default {"src":"/_next/static/media/NEM.a915acb7.svg","height":18,"width":18};